import { defineStore } from "pinia";

export const useErrorStore = defineStore("errorStore", {
    state: () => ({
        errors: []
    }),
    actions: {
        pushMessages(messages = []) {
            if (!Array.isArray(messages)) return;

            messages.forEach((message) => {
                if (message === undefined || message === null) return;

                const exists = this.errors.some((storedError) => {
                    if (storedError === message) return true;
                    try {
                        return JSON.stringify(storedError) === JSON.stringify(message);
                    } catch (e) {
                        return false;
                    }
                });

                if (!exists) {
                    this.errors.push(message);
                }
            });
        },
        removeErrorAt(index) {
            if (typeof index !== "number") return;
            if (index < 0 || index >= this.errors.length) return;
            this.errors.splice(index, 1);
        },
        removeError(error) {
            if (error === undefined) return;
            const index = this.errors.findIndex((storedError) => {
                if (storedError === error) return true;
                try {
                    return JSON.stringify(storedError) === JSON.stringify(error);
                } catch (e) {
                    return false;
                }
            });
            if (index !== -1) {
                this.errors.splice(index, 1);
            }
        },
        clearErrors() {
            this.errors = [];
        }
    }
});
